module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customViews.title":"Custom Views","customViews.subtitle":"Custom views are re-usable filters that can be applied to spend.","customViews.failedToLoad":"There was an issue loading the custom views."}}')
  delete Component.options._Ctor
}
